import { extendVariants, Link as LinkComponent } from "@heroui/react";

export const Link = extendVariants(LinkComponent, {
  defaultVariants: {
    color: "primary",
    underline: "hover",
  },
});
